export type ConfirmDialogData = {
  title: string;
  message: string;
  confirmMessage: string;
  cancelMessage: string;
};
